import React from "react";

export function RiskBadge({ risk }) {
  const cls =
    risk === "High" ? "risk-high" : risk === "Low" ? "risk-low" : "risk-medium";
  return (
    <span className={`risk-badge ${cls}`} data-testid={`risk-badge-${risk?.toLowerCase()}`}>
      <span className="inline-block w-1.5 h-1.5 rounded-full bg-current opacity-80" />
      {risk}
    </span>
  );
}

export function StatusPill({ status }) {
  const map = {
    Open: "status-open",
    "In-Progress": "status-progress",
    Resolved: "status-resolved",
    Closed: "status-closed",
  };
  return (
    <span className={`status-pill ${map[status] || "status-open"}`} data-testid={`status-${status}`}>
      {status}
    </span>
  );
}
